__turbopack_context__.v({
  "banner": "cb04lG_banner",
  "boldText": "cb04lG_boldText",
  "label": "cb04lG_label",
});
